import { createSlice } from "@reduxjs/toolkit";
import { BaseApiState } from "../../api/axiosConfig";
import {
  deleteExportFile,
  fetchExportResults,
  fetchFiles,
  loadExportFiltersData,
} from "../actions/exportResultsAction";
import { ExportFitersData } from "../../api/exportResultsApi";
import { FileData } from "../../api/psychologicalLabApi";

export interface ExportResultsState extends BaseApiState {
  refreshNeeded: boolean;
  loadingExportResults: boolean;
  succeededExportResults: boolean;
  succeededExportFiles: boolean;
  succeededDeletedExportFile: boolean;
  loadingExportFilters: boolean;
  loadingDeleteFile: boolean;
  loadingExportFiles: boolean;
  filters: ExportFitersData | null;
  exportFiles: FileData[] | null;
}

const exportResultsInitialState: ExportResultsState = {
  succeededExportResults: false,
  succeededDeletedExportFile: false,
  succeededExportFiles: false,
  loadingExportResults: false,
  loadingExportFiles: false,
  loadingExportFilters: false,
  loadingDeleteFile: false,
  refreshNeeded: false,
  loading: false,
  error: false,
  errorMessage: undefined,
  errorDetails: undefined,
  succeeded: false,
  filters: null,
  exportFiles: null,
};

const ExportResultsSlice = createSlice({
  name: "exportResults",
  initialState: exportResultsInitialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchExportResults.pending, (state) => {
        state.loadingExportResults = true;
        state.succeededExportResults = false;
        state.succeededDeletedExportFile = false;
      })
      .addCase(fetchExportResults.rejected, (state) => {
        state.succeededDeletedExportFile = false;
        state.loadingExportResults = false;
        state.succeededExportResults = false;
        state.error = true;
        state.errorMessage = undefined;
        state.errorDetails = undefined;
      })
      .addCase(fetchExportResults.fulfilled, (state) => {
        state.succeededDeletedExportFile = false;
        state.loadingExportResults = false;
        state.succeededExportResults = true;
        state.refreshNeeded = false;
      })
      .addCase(loadExportFiltersData.pending, (state) => {
        state.filters = null;
        state.loadingExportFilters = true;
      })
      .addCase(loadExportFiltersData.rejected, (state) => {
        state.filters = null;
        state.loadingExportFilters = false;
        state.error = true;
        state.errorMessage = undefined;
        state.errorDetails = undefined;
      })
      .addCase(loadExportFiltersData.fulfilled, (state, action) => {
        state.filters = action.payload;
        state.loadingExportFilters = false;
        state.succeeded = true;
        state.refreshNeeded = false;
      })
      .addCase(fetchFiles.pending, (state) => {
        state.loadingExportFiles = true;
        state.succeededExportFiles = false;
      })
      .addCase(fetchFiles.rejected, (state) => {
        state.loadingExportFilters = false;
        state.error = true;
        state.errorMessage = undefined;
        state.errorDetails = undefined;
        state.succeededExportFiles = false;
      })
      .addCase(fetchFiles.fulfilled, (state, action) => {
        state.exportFiles = action.payload;
        state.loadingExportFilters = false;
        state.succeededExportFiles = true;
        state.refreshNeeded = false;
      })
      .addCase(deleteExportFile.pending, (state) => {
        state.succeededExportResults = false;
        state.succeededDeletedExportFile = false;
        state.loadingDeleteFile = true;
      })
      .addCase(deleteExportFile.rejected, (state) => {
        state.succeededExportResults = false;
        state.error = true;
        state.errorMessage = undefined;
        state.errorDetails = undefined;
        state.succeededDeletedExportFile = false;
        state.loadingDeleteFile = false;
      })
      .addCase(deleteExportFile.fulfilled, (state) => {
        state.succeededExportResults = false;
        state.loadingDeleteFile = false;
        state.succeededDeletedExportFile = true;
        state.refreshNeeded = false;
      });
  },
});

export const exportResultsReducer = ExportResultsSlice.reducer;
